<template>
  <div class="Frame">
    <div class="PcDevice_block">
      <div class="d-flex align-items-center mb-4">
        <img src="../assets/images/user.svg" class="mr-3" style="width: 50px; height: 50px" alt="" />
        <div class="title_family">
          <h4>Đăng ký hội viên miễn phí</h4>
          <h6>Cập nhật thông tin triển lãm và chuyên ngành mọi lúc mọi</h6>
        </div>
      </div>
      <p>
        Nhanh chóng nắm bắt tin tức mới nhất về triển lãm, thông tin nhận vé sự kiện, ưu đãi và quyền lợi dành riêng cho
        hội viên Chan Chao, đồng thời nhận bản tin điện tử và báo cáo tin tức triển lãm miễn phí
      </p>
      <a href="https://www.chanchao.com.tw/accounts/vn/signup" class="btn btn-block btn-secondary mt-3">Đăng ký ngay</a>

      <hr />
    </div>

    <h4 class="my-4 title_family">Các câu hỏi thường gặp</h4>

    <ul class="ml-0 pl-4">
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
          target="_blank"
          >Làm thế nào để trở thành hội viên?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
          target="_blank"
          >Làm thế nào để nhận vé? Mã mời tham quan là gì?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88)_En.pdf"
          target="_blank"
          >Làm thế nào để nhanh chóng quét mã vào cửa??</a
        >
      </li>
    </ul>

    <div class="d-flex mt-3">
      <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
        >Câu hỏi thường gặp khác<i class="fas fa-external-link-alt ml-2"></i
      ></a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },

    methods: {},

    created() {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .Frame {
    font-family: Arial;
  }

  .title_family {
    font-family: 'sans-serif';
  }
</style>
